/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staples_EmptyInputs */

const en_staples_empty = /** @type {(inputs: Staples_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No staples yet`)
};

const de_staples_empty = /** @type {(inputs: Staples_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Vorräte`)
};

/**
* | output |
* | --- |
* | "No staples yet" |
*
* @param {Staples_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staples_empty = /** @type {((inputs?: Staples_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staples_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staples_empty(inputs)
	return en_staples_empty(inputs)
});